module.exports = __webpack_public_path__ + "media/images/responsive/flow/waso_step03-457d6cf610dc5f249b68de038cbbb5c9.jpg";